import Vue from 'vue'
import Router from 'vue-router'
// import store from '../store/index'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/404'
    },
    {
      path: '/other',
      component: () => import('@/views/other/index'),
      redirect: '/other/v1',
      children: [
        {
          path: 'v1',
          meta: {
            title: '测评报告'
          },
          component: () => import('@/views/other/v1')
        }
      ]
    },
    {
      path: '/404',
      component: () => import('@/components/NotFound')
    }
  ]
})

router.beforeEach((to, from, next) => {
  next()
  // const { title, needLogin } = to.meta
  // const { isLogin } = store.state
  // document.title = title

  // if (needLogin && !isLogin) {
  //   next({
  //     path: '/login'
  //   })
  // } else {
  //   next()
  // }
})

export default router
